import { assert } from '@ember/debug';
import { isPresent } from '@ember/utils';
import GroupItemType from '@square/dashboard-data/models/directory/group-item-type';
import { FilterConditions } from '@square/dashboard-data/models/squareup/rolodexdiscovery/filter';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
export const ContactSearchCriteria = ProtoBaseModel.extend({
  query: attr(String),
  conditions: attr(FilterConditions)
});
export const ContactSetType = new Enum(['ALL_CONTACTS', 'INCLUDED_CONTACTS', 'CONTACT_SEARCH_CRITERIA']);
export const ContactSet = ProtoBaseModel.extend({
  type: attr(ContactSetType),
  contactTokensIncluded: repeated(String),
  contactTokensExcluded: repeated(String),
  contactSearchCriteria: attr(ContactSearchCriteria)
});
export function createContactSet({
  checkedContacts,
  uncheckedContacts,
  isAllChecked,
  groupItem,
  searchTerm,
  filterAppliedV2
}) {
  const isAllCustomersGroup = !groupItem || groupItem.get('type') === GroupItemType.ALL;
  const contactSearchCriteria = ContactSearchCriteria.create({});
  let type = null;
  if (isAllChecked) {
    if (!isAllCustomersGroup || isPresent(searchTerm) || isPresent(filterAppliedV2)) {
      type = ContactSetType.CONTACT_SEARCH_CRITERIA;
      if (isPresent(searchTerm)) {
        contactSearchCriteria.set('query', searchTerm);
      }
      const filters = isPresent(filterAppliedV2) ? filterAppliedV2 : groupItem.filter;
      if (isPresent(filters)) {
        contactSearchCriteria.set('conditions', FilterConditions.create({
          any: [filters]
        }));
      }
    } else if (isAllCustomersGroup) {
      type = ContactSetType.ALL_CONTACTS;
    } else {
      assert('createContactSet could not determine type.');
    }
  } else {
    type = ContactSetType.INCLUDED_CONTACTS;
  }
  const contactTokensIncluded = type === ContactSetType.INCLUDED_CONTACTS ? checkedContacts.mapBy('contactToken') : null;
  const contactTokensExcluded = isAllChecked && isPresent(uncheckedContacts) ? uncheckedContacts.mapBy('contactToken') : null;
  return ContactSet.create({
    type,
    contactTokensIncluded,
    contactTokensExcluded,
    contactSearchCriteria
  });
}
export default ContactSet;